export default __webpack_public_path__ + "media/images/svg/graphic-bg-2-72242ac4ec3464944fdfa115bfacc3f5.svg";